<!--小企鹅登录-->
<template>
  <div class="steam">
    <myModal
      class="sign-login"
      :class="[inviteType == 'FREERU' ? 'freeru-login' : 'qie-login']"
      :style="anchorBgStyle"
      :visible="visible"
      centered
      @close="close($event)"
    >
      <template #cuscloseIcon>
        <img src="@/assets/images/index/loginclose.png" alt="" />
      </template>
      <template #mytitle>
        <!-- <div>{{ localTitle }}</div> -->
      </template>
      <template #body>
        <div class="def-login" v-if="localContentType == 'def'">
          <div class="login-info">
            <!-- 2026-10-14 主播弹窗配置化：文字走 i18n 模板，数值/图片由后端 anchor_popups 下发；未配置时回落原硬编码 -->
            <img v-if="anchorBadge" class="anchor-badge" :src="anchorBadge" alt="" />
            <div class="title">{{ anchorTitleText }}</div>
            <div class="txt" v-html="anchorLine1Html"></div>
            <div class="fuli" v-html="anchorLine2Html"></div>
          </div>
          <div class="options">
            <a-button class="stean-btn cbtn-def" @click="doLogin('steam', $event)">
              <template #icon>
                <!-- <img
                  class="btn-icon"
                  src="@/assets/images/index/login_steam.png"
                  alt=""
                /> -->
                <span class="btn-txt">{{ $t("loginLarge") }}</span>
              </template>
            </a-button>
          </div>

          <!-- <template v-if="isTest">
            <div class="devlogin">
              <div class="test" @click="testLogin">密码登录</div>
              <div class="test" @click="testLogin2">密码登录163</div>
            </div>
          </template> -->
        </div>
      </template>
    </myModal>
  </div>

  <div></div>
</template>

<script setup>
import { ref, reactive, toRaw, computed, onMounted } from "vue";
import showNotice from "@/components/common/notice/notice.js";
import $api from "@/api/index.js";
import $store from "@/store";
import { loginModal } from "@/components/common/login";
import { Form, message } from "ant-design-vue";
import handleResponse from "@/utils/handleResponseData.js";
import i18n from "@/i18n";
import { showRechargeRebateModal } from "@/utils/auth.js";
const { t: $t, locale } = i18n.global;
import { useRoute, useRouter } from "vue-router";
const route = useRoute(); // 获取当前路由
const useForm = Form.useForm;
const router = useRouter();

function testServicePolicy() {
  console.log("to service policy");
  router.push("policy/4");
}

const userStore = $store("user");
const isTest = import.meta.env.VITE_SHOW_TESTPAGE === "true";

const props = defineProps({
  visible: {
    type: Boolean,
    desc: "登录弹框开关",
    default: !false,
  },
  title: {
    type: String,
    desc: "登录弹框标题",
    default: "steam 登录",
  },
  // default 用 null：null=后端从未配置（走 i18n 兜底）；""=后台配了但清空（渲染为空）
  anchorTitle:    { type: String, default: null },
  anchorLine1:    { type: String, default: null },
  anchorLine2:    { type: String, default: null },
  bonusAmount:    { type: [Number, String], default: null },
    promoCode:      { type: String, default: "" },
    depositPercent: { type: [Number, String], default: null },
    promoImage:     { type: String, default: "" },
    badgeImage:     { type: String, default: "" },
    inviteType: {
    type: String,
    desc: "弹框类型==>小企鹅弹框,和freeru弹框",
    default: "",
  },
  contentType: {
    type: String,
    desc: "登录弹框,可选值为 def  reg  reset  email",
    default: "",
  },
});

//登录弹框内容类型 def-默认  reg-注册/找回密码页 email-邮箱验证码/密码登录页
// —— 主播弹窗配置（方案①：数值+图片来自后端，文字走 i18n 模板）——
const anchorCfg = computed(() => ({
  amount:   props.bonusAmount,
  code:     props.promoCode,
  percent:  props.depositPercent,
  image:    props.promoImage,
}));
const hasAnchorCfg = computed(() => anchorCfg.value.code !== "" && anchorCfg.value.code != null);
const escHtml = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '\"': "&quot;", "'": "&#39;" }[c]));
const anchorAmount = computed(() => {
  const n = Number(anchorCfg.value.amount);
  if (!isFinite(n) || n <= 0) return "";
  return "$" + (Math.round(n * 100) / 100).toString();
});
const anchorBadge = computed(() => (props.badgeImage && String(props.badgeImage).trim() !== "") ? props.badgeImage : "");
// null/undefined = 未配置（走 i18n 兜底）；空串 = 配了但清空（渲染为空）
const customLine1 = computed(() => (props.anchorLine1 === null || props.anchorLine1 === undefined) ? null : String(props.anchorLine1));
const customLine2 = computed(() => (props.anchorLine2 === null || props.anchorLine2 === undefined) ? null : String(props.anchorLine2));
const anchorTitleText = computed(() => {
  if (props.anchorTitle !== null && props.anchorTitle !== undefined) return String(props.anchorTitle);
  return hasAnchorCfg.value ? $t("anchorPopupTitle") : "Receive Bonus";
});
const anchorLine1Html = computed(() => {
  if (!hasAnchorCfg.value) {
    const legacyCode = (props.inviteType == "FREERU") ? "FREERU." : "CS2KINGUIN.";
    return 'You\'ll receive <span class="send-num">$0.5</span> by using the promocode <span class="txtlight">' + legacyCode + "</span>";
  }
  if (customLine1.value !== null) return escHtml(customLine1.value);
  return escHtml($t("anchorPopupLine1"))
    .replace("{amount}", '<span class="send-num">' + escHtml(anchorAmount.value) + "</span>")
    .replace("{code}", '<span class="txtlight">' + escHtml(anchorCfg.value.code) + "</span>");
});
const anchorLine2Html = computed(() => {
  if (customLine2.value !== null) return escHtml(customLine2.value);
  const n = Number(anchorCfg.value.percent);
  if (!hasAnchorCfg.value || !isFinite(n) || n <= 0) return '<span class="fuli-num">+10% bonus</span> on deposit.';
  return escHtml($t("anchorPopupLine2")).replace("{percent}", '<span class="fuli-num">+' + escHtml(n) + "%</span>");
});
const anchorBgStyle = computed(() => anchorCfg.value.image
  ? { backgroundImage: 'url("' + String(anchorCfg.value.image).replace(/"/g, "") + '")', backgroundSize: "cover", backgroundPosition: "right center" }
  : {});
const localContentType = ref(props.contentType);
//弹框标题
const localTitle = ref(props.title);
const emits = defineEmits(["close", "login", "reg", "rest", "email", "click"]);
const term1 = ref(false); //协议
const term2 = ref(false); //是否成年

//是否同意协议
function permit() {
  if (term1.value && term2.value) {
    return true;
  }
  showNotice("f", { desc: $t("requireAccept") });
  return false;
}

function toFAQ() {
  console.log("to FAQ");
}

function doLogin(type, e) {
  e.stopPropagation();

  loginModal(
    { visible: true, title: $t("loginLarge"), contentType: "def" },
    (callnack) => {
      // console.log('未登录 弹登录框');
      callnack();
    }
  );

  emits("close");

  // //通过steam登录
  // if ("steam" == type) {
  //   // console.log("steam login");
  //   //获取当前页面路由
  //   // 创建 URL 对象
  //   const url = new URL(window.location.href);
  //   // 获取当前页面的路径
  //   const currentPath = url.pathname;
  //   console.log("currentUrl:", currentPath);
  //   localStorage.setItem("currentPath", currentPath);
  //   userStore.from = currentPath;
  //   steamLogin();
  // }
}

//登录注册成功后更新站点数据
function LoginSuccessUpdate(res) {
  localStorage.setItem("token", res.access_token);
  showNotice("s", { desc: $t("loginSuccess") });
  //登录成功更新用户数据
  const token = localStorage.getItem("token");
  if (token) {
    userStore.$patch((state) => {
      state.isToken = true;
      if (state.count <= 1) {
        state.count++;
      } else {
        state.count = 1;
      }
      //tag  更新组件key  强制重新渲染组件 显示loading?
    });
    userStore.getUserInfo().then((res) => {
      console.log("登录成功,更新用户数据;", res);
      showRechargeRebateModal(userStore, $api, handleResponse);
      isClick.value = false;
    });
  }
  //更新数据后关闭登录弹框
  emits("close");
}

function steamLogin() {
  console.log("steam login");
  //地址栏有邀请码

  const params = {
    invite: null,
    client_id: localStorage.getItem('ga4_client_id')
  };
  const invite_id = localStorage.getItem("invite_id");
  if (invite_id) {
    params.invite = invite_id;
  }
  console.log("邀请码;", params);
  if (params.invite) {
    console.log("有邀请码");

    $api.user.loginSteam({ params: params }).then((res) => {
      console.log("steam res;", res);
      window.location.href = res.url;
    });
  } else {
    console.log("无邀请码");
    $api.user.loginSteam({ params: params }).then((res) => {
      console.log("steam res;", res);
      window.location.href = res.url;
    });
  }
}

onMounted(() => {
  handleLoginResponse();
});

async function handleLoginResponse() {
  // 这里可以使用一个 AJAX 请求去获取 token 信息 //bug  怎么拿到token???
  const response = await fetch(window.location.href); ////bug 地址栏 这里不知道怎么写
  console.log("response;", response);
  if (response) {
    const data = await response.json();
    // 保存 token 和用户信息
    // localStorage.setItem("token", data);

    // 假设你有一个存储用户信息的变量
  } else {
    // 错误处理
  }
}

const isClick = ref(false);

function testLogin() {
  if (isClick.value) return;
  isClick.value = true;
  loginByPwdForEmail();
}
function testLogin2() {
  loginByPwdForEmail2();
}

//邮箱密码登录测试163
function loginByPwdForEmail2() {
  const admin = {
    email: "1886853@gmail.com",
    // email: "18815526@gmail.com",

    password: "123456",
  };
  $api.user.emailLogin(admin).then((res) => {
    console.log("密码登录:", res);
    const resp = handleResponse(res);
    if (!resp) return console.log("未知错误", res.message);
    LoginSuccessUpdate(resp);
  });
}

//邮箱密码登录
function loginByPwdForEmail() {
  const admin = {
    email: "18882358@gmail.com",
    password: "a123456",
  };
  $api.user.emailLogin(admin).then((res) => {
    console.log("密码登录:", res);
    const resp = handleResponse(res);
    if (!resp) return console.log("未知错误", res.message);
    LoginSuccessUpdate(resp);
  });
}

//关闭登录弹框
function close(e) {
  e.stopPropagation();
  emits("close");
}
</script>
<style lang="scss" scoped>
.sign-login {
  :deep(.ant-modal) {
    width: 8rem !important;
    height: 3.3rem;
    border-radius: 0.1rem;
    .ant-modal-content {
      height: inherit;
      background-color: #0e121e;
      background-image: url("@/assets/images/index/qiesignup.webp");
      @extend %clearBgi;
    }
    .ant-modal-close {
      right: 0.3rem !important;
      top: 0.3rem !important;
    }

    .ant-modal-close-x {
      width: 0.2rem !important;
      height: 0.2rem !important;
      img {
        width: 0.2rem;
        height: 0.2rem;
      }
    }
    .ant-modal-header {
      // padding-top: 0.5rem;
      .ant-modal-title {
        justify-content: center;
        font-size: 0.31rem;
        font-weight: bold;
        color: #ffffff;
        font-family: "Microsoft YaHei";
      }
    }
    .ant-modal-body {
      display: flex;
      justify-content: center;

      //note 抽离按钮通用样式  宽度 背景色 icon等
      .cbtn-def {
        width: 2.7rem;
        height: 0.6rem;
        border-radius: 0.3rem;
        background-color: $active-color;
        font-size: 0.2rem;
        font-weight: bold;
        color: #ffffff;
        position: relative;
        @extend %flex-all-center;

        .btn-icon {
          position: static;
          transform: none;
          width: 0.3rem;
          height: 0.3rem;
          margin-right: 0.2rem;
        }
        .btn-txt {
          font-size: 0.2rem;
          font-weight: bold;
          color: #ffffff;
        }
      }

      //默认
      .def-login {
        // border: 2px solid red;
        width: 8rem;
        height: 3.3rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        .login-info {
          position: relative;
          height: 4rem;
          padding-left: 1.7rem;
          padding-top: 0.51rem;
          .title {
            font-weight: bold;
            font-size: 0.24rem;
            color: #1ec9a7;
          }
          .txtlight {
            font-weight: bold;
            color: #1ec9a7;
          }
          .txt {
            width: 3rem;
            font-weight: 400;
            font-size: 0.18rem;
            color: #91a2b7;
            line-height: 0.22rem;
            transform: translateY(0.02rem);
            .send-num {
              font-weight: bold;
              color: #1ec9a7;
            }
          }
          .fuli {
            position: absolute;
            left: 1.35rem;
            bottom: -0.3rem;
            font-weight: 400;
            font-size: 0.22rem;
            color: #91a2b7;
            .fuli-num {
              font-weight: bold;
              font-size: 0.22rem;
              color: #20dfb9;
            }
          }
        }
        .options {
          // border: 2px solid yellow;
          margin-top: 0.57rem;
          margin-left: 1.21rem;
          margin-bottom: 0.4rem;
          .reg-info {
            cursor: pointer;
            text-align: center;
            .sp1 {
              color: #343c50;
            }
            .link {
              text-decoration: underline;
              color: $active-color;
            }
          }
        }
      }

      .devlogin {
        position: absolute;
        top: 70%;
      }
    }
  }
}

.qie-login {
  :deep(.ant-modal) {
    .ant-modal-content {
      background-image: url("@/assets/images/index/qiesignup.webp");
    }
  }
}
.freeru-login {
  :deep(.ant-modal) {
    .ant-modal-content {
      background-image: url("@/assets/images/index/freerusignup.webp");
    }
  }
}
.anchor-badge {
  position: absolute;
  /* 必须用 rem：本弹窗全部尺寸都是 rem（main.js 里 fontSize = 100 * clientWidth/1920，
     即 1rem = 窗口宽/19.2），写死 px 会导致窗口放大时头像不跟着放大。
     基准换算（1280px 窗口，1rem = 66.67px）：78px ⇒ 1.17rem；
     位置按需求在 22px/18px 基础上右移 5px、下移 8px ⇒ 27px/26px ⇒ 0.40rem/0.39rem；
     随后再左移 3px ⇒ 24px ⇒ 0.36rem（top 保持 0.39rem）。
     定位父元素是 .login-info（已实测 offsetParent 确认），其左上与弹窗左上重合。 */
  top: 0.39rem;
  left: 0.36rem;
  width: 1.17rem;
  height: 1.17rem;
  border-radius: 50%;
  object-fit: cover;
  z-index: 2;
}
</style>
